import { createClient } from '@/shared/api';
import type {
  CreateReferringPhysicianMutation,
  CreateReferringPhysicianMutationVariables,
} from '@/shared/api';
import CREATE_REFERRING_PHYSICIAN_MUTATION from '../mutations/createReferringPhysician';

/**
 * Creates a referring physician for a facility from the submitted user information. Sends CREATE_REFERRING_PHYSICIAN_MUTATION and throws the mutation's message when isSuccess is false, otherwise returning the created user.
 *
 * @param userInfo - Personal and contact details of the referring physician.
 * @param facility - Facility the referring physician belongs to.
 * @returns The newly created referring physician user.
 */
const handleCreateReferringPhysician = async (userInfo: any, facility: any) => {
  const client = createClient();
  const createReferringPhysicianResult = await client.mutate<
    CreateReferringPhysicianMutation,
    CreateReferringPhysicianMutationVariables
  >({
    mutation: CREATE_REFERRING_PHYSICIAN_MUTATION,
    variables: {
      userInfo,
      facility,
    },
  });
  if (!createReferringPhysicianResult?.data?.createReferringPhysician.isSuccess) {
    throw new Error(
      createReferringPhysicianResult?.data?.createReferringPhysician?.message ?? undefined,
    );
  }
  return createReferringPhysicianResult?.data?.createReferringPhysician?.user;
};

export default handleCreateReferringPhysician;
